// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
            <path
                fill="currentColor"
                d="M12,2 L10.75,2 L10.75,0.75 C10.75,0.3359375 10.4140625,0 10.0281248,0 C9.64218712,0 9.25,0.3359375 9.25,0.75 L9.25,2 L4.75,2 L4.75,0.75 C4.75,0.3359375 4.4156251,0 4,0 C3.5843749,0 3.25,0.3359375 3.25,0.75 L3.25,2 L2,2 C0.895312309,2 0,2.89531231 0,4 L0,14 C0,15.1046877 0.895312309,16 2,16 L12,16 C13.1046877,16 14,15.1046877 14,14 L14,4 C14,2.89531231 13.1031246,2 12,2 Z M11.9999995,14.5 L1.99999952,14.5 C1.72431231,14.5 1.49999952,14.2757502 1.49999952,14 L1.49999952,6 L12.4999995,6 L12.4999995,14 C12.4999995,14.2749996 12.2749991,14.5 11.9999995,14.5 L11.9999995,14.5 Z"
            />
        </svg>
    );
};

export default React.memo(Calendar);
